import { render } from "./ConfirmModal.vue?vue&type=template&id=f1ebba90&ts=true&lang=html"
import script from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./ConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__